module.exports = __webpack_public_path__ + "img/heart_red_big.efcd7756.svg";